import React from 'react';
import { PlayTagWrapper } from './PlayTag.styles';
import PropTypes from 'prop-types';

const PlayTag = (props) => <PlayTagWrapper {...props} />;

PlayTag.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    className: PropTypes.string,
    query: PropTypes.object,
    hash: PropTypes.string,
    state: PropTypes.object,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.string,
    children: PropTypes.node,
    isExternal: PropTypes.bool,
    isIndexLink: PropTypes.bool,
    scrollToTop: PropTypes.bool,
    onClick: PropTypes.func,

    onAfterClick: PropTypes.func,
    regTestSpec: PropTypes.string,
};

export default PlayTag;
